<template>
  <div class="articleDialog-container">
    <el-dialog
        :visible.sync="showArticle"
        width="850px"
        :before-close="handleClose">
      <div class="article-inner" v-if="info">
        <div class="title">{{info.title}}</div>
        <div class="issue">《{{ info.magazineName }}》 {{info.Year}}年 第{{info.Issue}}期</div>
        <div class="content" v-html="info.content"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  },
  props:['showArticle','info'],
  methods:{
    handleClose(){
      this.$emit('showArticleDialog',false)
    },
  }
}
</script>

<style lang="less">
.articleDialog-container{
  .el-dialog{
    height:calc(83%);
  }
  .el-dialog__body{
    height: calc(100% - 200px);
  }
  .article-inner{
    height: 100%;
    .title{
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      margin-bottom: 20px;
    }
    .issue{
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #909399;
      border-bottom: 1px solid #E6E6E6;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    .content{
      height: 95%;
      overflow-y: auto;
      font-size: 15px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
    }
  }
}
</style>
